export enum CloudDiskModule {
  /** 控制台 带租户 */
  CONSOLE = 'console',
  /** 平台 不带租户 */
  PLATFORM = 'platform',
}

export enum CloudDiskType {
  /** 裸金属 */
  BARE_METAL = 'bare-metal',
  /** 云主机 */
  CLOUD_HOST = 'cloud-host',
}

export enum VolumeDiskType {
  /** 系统盘 */
  SYSTEM = 'System',
  /** 数据盘 */
  DATA = 'Data',
}

/** 云盘的唯一标识符类型 - 适配具体业务的每一种情况 */
export type CloudDiskKey = `${CloudDiskModule}|${CloudDiskType}`;

/** 云盘组件的根类型 - 用于区分不同平台和类型下的数据处理和 UI 表现
 * 该接口用于定义云盘组件的基本属性，便于在不同平台和类型下进行统一管理和展示
 * 例如：在控制台和平台上可能有不同的云盘类型和平台，但都可以通过该接口进行统一处理
 * @example interface YOUR_COMPONENT extends CloudDiskComponent {
 *   // 其他属性
 * }
 */
export interface CloudDiskComponent {
  /** 云盘类型 */
  type: CloudDiskType;
  /** 云盘组件位于哪个业务模块 */
  module: CloudDiskModule;
}

/** useParams 相关的参数 */
export interface CloudDiskUseParams {
  /** 租户空间 - 控制台才有 */
  tenant?: string;
  /** 集群 */
  cluster?: string;
  /** 云盘名称 */
  id?: string;
  /** 其他 */
  [key: string]: string | undefined;
}

/** 云盘详情页的 Tab 页 */
export enum CloudDiskDetailTabs {
  /** 资源规格 */
  RESOURCE_SPEC = 'resource-spec',
  /** 资源状态 */
  RESOURCE = 'resource',
  /** 元数据 */
  METADATA = 'metadata',
  /** 事件 */
  EVENT = 'event',
  /** 状态 */
  STATUS = 'status',
  /** 镜像工厂 */
  IMAGE_FACTORY = 'image-factory',
}

/** 云盘相关的路由跳转页面路径 */
export interface CloudDiskRoutePaths {
  listPath: string;
  detailPath: string;
  createPath: string;
}

export enum CloudDiskResourceType {
  S3 = 'S3',
  HTTP = 'HTTP',
  BLANK = 'Blank',
  REGISTRY = 'Registry',
  PVC = 'PVC',
  IMAGE_FACTORY = 'ImageFactory',
}
